import {
  Container,
  MainButton,
} from "./CreditPaymentImporterConfirmationStyles";

function CreditPaymentImporterConfirmation(props) {
  const { onConfirm, payerRucOption } = props;
  return (
    <Container>
      <h1>Documento requerido</h1>
      {payerRucOption === "consignee" ? (
        <p>
          Necesita adjuntar un documento para poder autorizar el pago con el
          crédito del importador.
        </p>
      ) : (
        <p>
          Necesita adjuntar un documento para poder autorizar el pago con el
          crédito del Agente de Carga.
        </p>
      )}
      <MainButton onClick={onConfirm}>Adjuntar documento</MainButton>
    </Container>
  );
}

export default CreditPaymentImporterConfirmation;
